/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PatientDemographicsIntegrationViewModel } from './patientDemographicsIntegrationViewModel';
import { PatientBalanceIntegrationViewModel } from './patientBalanceIntegrationViewModel';
import { PatientServiceDatesIntegrationViewModel } from './patientServiceDatesIntegrationViewModel';
import { PatientInsuranceIntegrationViewModel } from './patientInsuranceIntegrationViewModel';
import { GuarantorDemographicsIntegrationViewModel } from './guarantorDemographicsIntegrationViewModel';
import { PatientVisitDetailsIntegrationViewModel } from './patientVisitDetailsIntegrationViewModel';

/**
 * Patient Details view model containing Patient and Guarantor demographics,  Insurances, Dates of Service, and Balances
 */
export interface PatientDetailsIntegrationViewModel {
  /**
   * Dataset Id (not used for Add)
   */
  datasetId?: string;
  /**
   * Patient account number
   */
  accountNumber?: number;
  /**
   * External Account Number
   */
  externalAccountNumber?: string | null;
  patient?: PatientDemographicsIntegrationViewModel;
  guarantor?: GuarantorDemographicsIntegrationViewModel;
  insurances?: Array<PatientInsuranceIntegrationViewModel> | null;
  visits?: Array<PatientVisitDetailsIntegrationViewModel> | null;
  datesOfService?: Array<PatientServiceDatesIntegrationViewModel> | null;
  balanceDetails?: PatientBalanceIntegrationViewModel;
  /**
   * Current patient balance
   */
  patientBalance?: number;
  /**
   * Current insurance balance
   */
  insuranceBalance?: number;
}
